<h2>{{ productLinkTitle }}</h2>
<ng-container *ngIf="productSKUs$ | async as productSKUs">
  <div *ngIf="productSKUs.length" class="product-list-container">
    <div class="product-list">
      <swiper [config]="swiperConfig">
        <ng-template *ngFor="let sku$ of productSKUs" swiperSlide let-data>
          <ish-product-item
            *ngIf="lazyFetch(data.isVisible, sku$) | async as sku"
            ishProductContext
            [sku]="sku"
          ></ish-product-item>
        </ng-template>
      </swiper>
    </div>
  </div>
</ng-container>
<div *ngIf="categories.length" class="product-list-container">
  <h3>{{ 'dias.product.category.link.text' | translate }}</h3>
  <div class="row">
    <div *ngFor="let categoryid of categories">
      <custom-product-category-link [categoryUniqueId]="categoryid"></custom-product-category-link>
    </div>
  </div>
</div>
